import script from "./custom-survey.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-survey.vue?vue&type=script&setup=true&lang=js"

import "./custom-survey.vue?vue&type=style&index=0&id=8d766690&lang=scss"

const __exports__ = script;

export default __exports__